import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import imagysolo from "../assets/imagysolo.png";
import botImagy from "../assets/botImagy.png";
import "../css/ImagySection.css";

const ImagySection = () => {
  const [visible, setVisible] = useState(false); // Animación al aparecer
  const [flipped, setFlipped] = useState(false); // Giro de la card
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    const currentRef = sectionRef.current;
    if (currentRef) observer.observe(currentRef);
    return () => currentRef && observer.unobserve(currentRef);
  }, []);

  return (
    <>
      <div ref={sectionRef} className="imagy-section">
        <Container>
          <Row className={`align-items-center fade-slide ${visible ? "visible" : ""}`}>
            <Col md={6}>
              <h2 className="section-title">Conocé a Imagy</h2>
              <p className="section-text" style={{ textAlign: 'justify' }}>
                Automatiza la gestión de turnos, responde preguntas frecuentes y reduce el trabajo repetitivo de forma eficiente y profesional.
                Está acompañado de un dashboard web personalizado, ideal para recepcionistas o administradores que necesitan visualizar y gestionar los turnos en tiempo real.
                Además, incluye una aplicación para celulares Android que permite consultar y controlar toda la operación desde cualquier lugar.
                Imagy se adapta a tu negocio, mejora la atención al cliente y libera tiempo valioso para que puedas enfocarte en lo importante.
              </p>
              <Button
                variant="warning"
                size="lg"
                onClick={() => {
                  const section = document.getElementById("contacto");
                  if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                Quiero crear mi cuenta gratis
              </Button>
            </Col>

            <Col md={6} className="text-center position-relative">
              <div className="speech-bubble">¡Hola! Soy Imagy 👋</div>
              <div className={`flip-card ${flipped ? "flipped" : ""}`} onClick={() => setFlipped(prev => !prev)}>
                <div className="flip-card-inner">
                  <div className="flip-card-front">
                    <img src={imagysolo} alt="Imagy saludando" style={{ width: "100%", borderRadius: "15px" }} />
                  </div>
                  <div className="flip-card-back">
                    <img src={botImagy} alt="Detalle Imagy" style={{ width: "100%", borderRadius: "15px" }} />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="svg-transition">
        <svg viewBox="0 0 1440 40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <defs>
            <linearGradient id="imagyGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#FFA500" />
              <stop offset="100%" stopColor="#FFE0B2" />
            </linearGradient>
          </defs>
          <path fill="url(#imagyGradient)" d="M0,0 C720,40 720,0 1440,40 L1440,0 L0,0 Z"></path>
        </svg>
      </div>

      {/* Estilos embebidos para speech bubble responsive */}
      <style>
        {`
          .speech-bubble {
            position: absolute;
            top: -20px;
            right: 30px;
            background-color: #fff;
            border: 2px solid #ffa500;
            border-radius: 10px;
            padding: 10px 14px;
            font-weight: bold;
            color: #444;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            z-index: 10;
          }

          @media (max-width: 768px) {
            .speech-bubble {
              top: -10px;
              right: auto;
              left: 50%;
              transform: translateX(-50%);
              max-width: 80%;
              font-size: 14px;
              text-align: center;
            }
          }
        `}
      </style>
    </>
  );
};

export default ImagySection;
